module.exports = __webpack_public_path__ + "img/消息通知.e9dee8be.png";